















































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineAPI, PipelinePhaseAPI } from '@/api/backend-client'
import { v4 as uuid} from 'uuid'

@Component
export default class ImportPipelinePhasesModal extends Vue {
    @Prop({ required: true }) readonly pipeline!: Pipeline
    @Prop({ required: true }) readonly pipelines!: Pipeline[]
    @Prop({ type: Boolean, default: false }) readonly value!: boolean
    @Prop({ type: Boolean, default: false }) readonly showPhaseWarning!: boolean

    visible: boolean = false
    loading: boolean = false

    selectedPipeline = null

    @Watch('value')
    onValueChanged(): void {
        this.visible = this.value
    }

    @Watch('visible')
    onVisibleChanged(): void {
        this.$emit('input', this.visible)
    }

    async importPhases(): Promise<void> {
        try {
            this.loading = true

            const originPipeline = await PipelineAPI.get(this.selectedPipeline, true)
            const targetPipeline = await PipelineAPI.get(this.pipeline.id, true)

            const deletePromises = []

            targetPipeline.phases.forEach(phase => {
                deletePromises.push(PipelinePhaseAPI.delete(phase.id))
            })

            await Promise.all(deletePromises)

            const createPhasePromises = []

            originPipeline.phases.forEach(phase => {
                const newPhase = phase.clone()
                newPhase.id = uuid()
                newPhase.pipeline = targetPipeline
                createPhasePromises.push(PipelinePhaseAPI.create(newPhase))
            })

            await Promise.all(createPhasePromises)

            this.$emit('on-save')
            this.hideModal()

        } finally {
            this.loading = false
        }
    }

    showModal(): void {
        this.visible = true
    }

    hideModal(): void {
        this.visible = false
    }

    get pipelineOptions(): Array<{label: string, value: string}> {
        return this.pipelines
            .filter(pipeline => pipeline.id !== this.pipeline.id)
            .map(pipeline => {
                return {
                    label: pipeline.name,
                    value: pipeline.id,
                }
            })
    }
}
